import { CheckPermissionsModes, checkPermissions } from "@elit-hair/elit-tools";

import { PERMISSIONS } from "@/constants/permissions";

import { REPORT_DASHBOARD_IDS, type ReportDashboardId } from "../types";

export const REPORTS_PAGE_PERMISSIONS: string[] = [
    PERMISSIONS.CALL_REPORTS_PRP_ADMIN,
    PERMISSIONS.CALL_REPORTS_SALES_ADMIN,
    PERMISSIONS.CALL_SETTING_PRIORITY_COUNTS,
    PERMISSIONS.CALL_CALENDAR_CAPACITIES,
    PERMISSIONS.CALL_DASHBOARD_AGENT_PERFORMANCE,
    PERMISSIONS.CALL_SVC_TEAM_LEAD_BASE,
    PERMISSIONS.CALL_SVC_ADMIN_BASE,
    PERMISSIONS.CALL_REACHABILITY_ANALYSIS,
];

const REPORT_DASHBOARD_ACCESS: Record<ReportDashboardId, { permissions: string[]; mode?: CheckPermissionsModes }> = {
    [REPORT_DASHBOARD_IDS.SALES_DACH]: {
        permissions: [PERMISSIONS.CALL_REPORTS_SALES_ADMIN],
    },
    [REPORT_DASHBOARD_IDS.SALES_PRP]: {
        permissions: [PERMISSIONS.CALL_REPORTS_PRP_ADMIN],
    },
    [REPORT_DASHBOARD_IDS.SETTING_CAPACITIES]: {
        permissions: [PERMISSIONS.CALL_SETTING_PRIORITY_COUNTS],
    },
    [REPORT_DASHBOARD_IDS.CALENDAR_CAPACITIES]: {
        permissions: [PERMISSIONS.CALL_CALENDAR_CAPACITIES],
    },
    [REPORT_DASHBOARD_IDS.TEAM_PERFORMANCE]: {
        permissions: [PERMISSIONS.CALL_DASHBOARD_AGENT_PERFORMANCE],
    },
    [REPORT_DASHBOARD_IDS.CALL_VOLUME]: {
        permissions: [PERMISSIONS.CALL_SVC_TEAM_LEAD_BASE, PERMISSIONS.CALL_SVC_ADMIN_BASE],
        mode: CheckPermissionsModes.ANY,
    },
    [REPORT_DASHBOARD_IDS.REACHABILITY_ANALYSIS]: {
        permissions: [
            PERMISSIONS.CALL_SVC_TEAM_LEAD_BASE,
            PERMISSIONS.CALL_SVC_ADMIN_BASE,
            PERMISSIONS.CALL_REACHABILITY_ANALYSIS,
        ],
        mode: CheckPermissionsModes.ANY,
    },
};

export function canViewReportDashboard(id: ReportDashboardId, permissionCodes: string[]): boolean {
    const access = REPORT_DASHBOARD_ACCESS[id];
    return checkPermissions(permissionCodes, access.permissions, access.mode);
}
